/* eslint-disable react/no-array-index-key */
import {Link} from 'react-router-dom'

import './index.css'

const CheckOut = () => (
  <div className="checkout-container">
    <div className="confetti">
      {Array.from({length: 30}).map((_, i) => (
        <span key={i} className="confetti-piece" />
      ))}
    </div>

    <div className="checkout-card">
      <h1 className="CheckOut-head">🎉 Order Placed Successfully!</h1>
      <p className="checkout-desc">Check out our latest deals</p>

      <Link to="/products">
        <button type="button" className="deals-btn">
          Deals
        </button>
      </Link>
    </div>
  </div>
)

export default CheckOut
